module.exports = __webpack_public_path__ + "img/news.6251e8a1.png";